<template>
  <div class="basic_wrap">
    <div class="nav_box">
      <van-tabs v-model="active" class="van-tabs__wrap--scrollable" offset-top="1.2rem" lazy-render @change="tabChange">
        <van-tab :title="$t('活动')" />
        <van-tab :title="$t('邀请')" />
        <van-tab :title="$t('贵宾')" />
        <van-tab :title="$t('回扣')" />
        <van-tab :title="$t('历史')" />
      </van-tabs>
    </div>
    <div v-if="active == 0" class="sideBox" :style="{ height: screenHeight + 'px' }">
      <div class="sign-box" v-if="signData.status == 1">
        <div class="sign-title">
          <div class="sign-text">
            <div>{{ $t('定金') }} + 60%</div>
            <div style="font-weight: 400;font-size: .43rem;margin-top: .2rem;">{{ $t('每天充值，每天领取奖励！') }}</div>
          </div>
          <img src="https://cdn.bz999xyz.xyz/image/DailyRechargeCheckIn/DailyRechargeCheckIn_logo.png" alt="">
        </div>
        <div class="sign-checkIn_box">
          <div class="checkIn-title">
            {{ $t('已联系您办理登机手续') }} <span class="title">0</span> {{ $t('连续天数') }}
          </div>
          <div class="checkIn-list">
            <div class="list-item" :class="signData.days == index ? 'itemActive' : ''"
              v-for="(item, index) in signData.list">
              <div class="item-title"> {{ item.title }} </div>
              <img src="https://cdn.bz999xyz.xyz/image/DailyRechargeCheckIn/DailyRechargeCheckIn_jinbi.png" alt="">
              <div class="amount_text">+{{ item.money }}</div>
            </div>
          </div>
          <div class="checkIn-btn" :class="signData.is_signin == 1 ? 'activBtn' : ''" @click="sign()">
            {{ $t('登入') }}
          </div>
          <div class="checkIn-btn btn" @click="toArticle">
            {{ $t('细节') }}
          </div>
        </div>
      </div>
      <div class="side_content">
        <div v-for="(item, index) in activ_list" :key="index" class="side_img" @click="jump(item, index)">
          <img :src="getImagePath(index)" alt="">
        </div>
      </div>
    </div>

    <div v-if="active == 1">
      <share />
    </div>
    <div v-if="active == 2">
      <cVip @toHis="toHis" />
    </div>
    <div v-if="active == 3">
      <rebate />
    </div>
    <div v-if="active == 4">
      <history />
    </div>
    <!-- <ftNav /> -->
  </div>
</template>
<script>
import Fetch from "../../utils/fetch";

import Vue from "vue";
import ftNav from "../../components/footer_nav/footer_nav";
import share from "../share/share.vue";
import cVip from "../vip/vip.vue";
import rebate from "../rebate/rebate.vue";
import history from "../history/history.vue";
import {
  Tab,
  Tabs,
  Progress,
  Empty,
  Dialog,
  Field,
  Sidebar,
  SidebarItem,
} from "vant";

Vue.use(Tab)
  .use(Tabs)
  .use(Progress)
  .use(Empty)
  .use(Dialog)
  .use(Field)
  .use(Sidebar)
  .use(SidebarItem);
export default {
  name: "Activity",
  components: {
    ftNav,
    share,
    cVip,
    rebate,
    history,
  },
  data() {
    return {
      checkActive: 0,
      is_open: false,
      bonus: 0.0,
      activeItem: [],
      group_service: null,
      active: 0,
      sidebar_active: 0,
      activ_list: [],
      timer: false,
      screenHeight: "",
      signData: {}
    };
  },
  watch: {
    screenHeight(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenHeight);
          that.timer = false;
        }, 400);
      }
    },
  },
  created() {
    this.$bus.$emit("send2ftnav", 1);
  },
  beforeDestroy() { },
  mounted() {
    this.getActivity();
    const activeId = Number(this.$route?.query?.tab) || 0;
    this.tabChange(activeId);
    var that = this;
    window.screenHeight = document.body.clientHeight - 110;
    that.screenHeight = window.screenHeight;
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight - 110;
        that.screenHeight = window.screenHeight;
      })();
    };
  },
  methods: {
    getImagePath(index) {
      return require(`@/assets/images/act/${index + 1}.png`);
    },
    tabChange(v) {
      this.active = v;
    },
    toArticle() {
      this.$router.push({
        path: "/article",
        query: { "signShow": "true", index: 6 },
      });
    },
    toHis() {
      this.active = 4;
    },
    getActivity() {
      this.activ_list = [
        {
          image: "../../assets/images/act/1.png",
        },
        {
          image: "../../assets/images/act/2.png"
        },
        {
          image: "../../assets/images/act/3.png",
        },
        {
          image: "../../assets/images/act/4.png",
        },
        {
          image: "../../assets/images/act/5.png",

        },
        {
          image: "../../assets/images/act/6.png",

        },
        Fetch("/activity/siginConfig", {
          name: "signin_bonus"
        }, { method: 'get' }).then(res => {
          this.signData = res.data;

        })
        // {
        //   image: "../../assets/images/act/7.png",

        // },
      ]
    },
    sign() {
      if (this.signData.is_signin == 0) {
        return;
      }
      Fetch("/activity/signin", {
      }).then(res => {
        if (res.data) {
          this.signData = res.data;
        }
      })
    },
    jump(item, index) {
      if (index == 0) {
        // this.$router.push({
        //   path: "/agent",
        //   query: { index: index },
        // });
        this.active = 1
      } else if (index == 2) {
        // console.log(item)
        this.$router.push({
          path: "/turnTable",
          query: { index: index },
        });
      } else if (index == 6) {
        this.$router.push({
          path: "/activity/red",
          query: { index: index },
        });
      } else {
        this.$router.push({
          path: "/article",
          query: { index: index },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

.nav_box {
  background-color: @secondary-color;
}

/deep/ .van-nav-bar--fixed {
  z-index: 2;
}

/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/.van-tab__text {
  font-size: 0.3rem;
  color: #fff;
}

:deep(.van-tab--active) {
  .van-tab__text {
    color: @textcolor1 !important;
  }
}

/deep/.van-tabs__line {
  background: @ButtonColor;
  height: 0.04rem;
}

@media (min-width: @maxWidth) {
  :deep(.van-sticky) {
    position: static !important;
  }
}

/deep/ .van-tabs__nav {
  padding-left: 0;
  padding-right: 0;
  background-color: @secondary-color;
}

.activBtn {
  background-color: @ButtonColor !important;
}

.btimg {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}

.tab_side {
  display: flex;
  flex-direction: column;
  // padding-left: 0.4rem;
  width: 25%;

  .tab_side_title {
    width: 2rem;
    height: 38px;
    background-color: @rechargeColor;
    border-radius: 6px;
    text-align: center;
    margin: 0 auto;
    text-align: center;
    margin-top: 20px;
    box-sizing: border-box;

    img {
      width: 0.4rem;
      margin-top: .1rem;
    }

    div {
      color: @textcolor6;
      font-size: 9px;
    }
  }

  .tab_his_title {
    width: 1.8rem;
    height: 0.8rem;
    line-height: 0.8rem;
    background-color: @rechargeColor;
    border-radius: 6px;
    text-align: center;
    margin: 0 auto;
    margin-top: 0.3rem;

    div {
      color: @textcolor6;
      font-size: 10px;
    }
  }
}

.svg_left {
  fill: @textcolor1;
}

.sideBox {
  // display: flex;
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .side_content {


    .side_img {
      width: 95%;
      // background-color: @secondary-color;
      text-align: center;
      margin: 0 auto;
      margin-top: 0.2rem;
      padding: 0.1rem;
      border: 1px solid @bodercolor;
      border-radius: 0.3rem;

      img {
        width: 95%;
        border-radius: 0.2rem;
      }
    }
  }

  .sign-box {
    width: 95%;
    border-radius: 0.3rem;
    margin: 0 auto;
    box-sizing: border-box;
    margin-top: .6rem;
    background-color: @primary-color;
    padding-bottom: .3rem;

    .sign-title {
      display: flex;
      align-items: center;
      margin-bottom: .3rem;

      .sign-text {
        flex: 1;
        margin-left: .3rem;
        padding-top: .3rem;
        color: #ffffff55;
        font-size: .48rem;
        font-weight: 700;
      }

      img {
        width: 2rem;
        margin-top: -0.6rem;
      }
    }

    .sign-checkIn_box {
      width: 95%;
      margin: 0 auto;
      background-color: #fff;
      border-radius: .3rem;
      color: #333;
      padding: .3rem .2rem;
      box-sizing: border-box;

      .checkIn-title {
        font-weight: 600;
        font-size: .34rem;
        margin-bottom: .3rem;

        span {
          color: @rechargeColor;
        }
      }

      .checkIn-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: .2rem;

        .list-item {
          padding: .2rem .4rem;
          text-align: center;
          background-color: rgba(191, 164, 253, .1);
          box-sizing: border-box;
          border-radius: .2rem;

          .item-title {
            font-weight: 600;
            font-size: .32rem;
            color: #333;
            margin-bottom: .2rem;
          }

          .amount_text {
            font-weight: 600;
            font-size: .24rem;
            color: #999;
          }

          img {
            width: 1rem;
          }
        }

        .itemActive {
          border: 1px solid @rechargeColor;
        }
      }

      .checkIn-btn {
        width: 97%;
        padding: .25rem 0;
        text-align: center;
        margin: 0 auto;
        background-color: @checkInbtn;
        border-radius: .4rem;
        margin-top: .3rem;
        color: #fff;
        font-size: .35rem;
        font-weight: 600;
      }

      .btn {
        background-color: #fff;
        color: @rechargeColor;
        border: 1px solid @rechargeColor;
      }
    }
  }
}

.aitwrap {
  width: 100%;
  overflow: hidden;
  position: relative;
  max-height: 100vh;
  //height: 100%;
}

.myteam-bg {
  width: 100%;
  height: 3rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.aitem_l {
  width: 22%;
  float: left;
  padding: 0.5rem 0 0 2%;
}

.l_one {
  display: block;
  padding: 0.1rem 0;
  background-color: #f9b818;
  color: #000000;
  text-align: center;
  border-radius: 0.2rem;
  width: 80%;
  margin: 0 auto;
}

.l_one img {
  width: 0.55rem;
  margin-bottom: 0.1rem;
}

.l_two {
  display: block;
  padding: 0.2rem 0;
  background-color: #999999;
  color: #fff;
  text-align: center;
  border-radius: 0.1rem;
  font-size: 0.24rem;
  width: 80%;
  margin: 0.2rem auto;
}

.l_three {
  display: block;
  padding: 0.2rem 0;
  background-color: #f9b818;
  color: #000000;
  text-align: center;
  border-radius: 0.1rem;
  font-size: 0.24rem;
  width: 80%;
  margin: 0.2rem auto;
}

.aitem_r {
  width: 100%;
  height: calc(100vh - 2.3rem);
  float: right;
  // overflow-y: scroll;
  overflow-x: hidden;
}

.details {
  text-align: center;
  margin-top: 10px;
  color: #82a504;
  font-size: 16px;
  font-weight: 600;
}

.box-wrap {
  position: relative;
}

.bonus {
  text-align: center;
  font-size: 0.8rem;
  color: gold;
  position: absolute;
  bottom: 10px;
  width: 100%;
  font-weight: 700;
  // left: 41%;
}

.box {
  width: 60%;
  height: auto;
  display: block;
  margin: 20% auto 18px;
}

.open-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  //background-color: rgba(0, 0, 0, 0.5);
  background: #0e4114;
  z-index: 3;
}

.ades {
  margin-top: 10px;
  font-size: 0.37rem;
  color: rgba(255, 255, 255, 0.737);
  line-height: 20px;
  text-indent: 10px;
}

.aname {
  font-size: 0.33rem;
  line-height: 18px;
  color: #88b19f;
}

.aitem {
  width: 100%;
  // height: 3rem;
  position: relative;
  padding-bottom: 0.2rem;
  background-color: @secondary-color;
  box-sizing: border-box;
  padding: 0.15rem;
  margin-bottom: 0.2rem;
  border-radius: 0.2rem;
}

.basic_wrap {
  background-color: @activityColor;
  min-height: 100vh;
  width: 100%;
}

.daily-gift {
  position: absolute;
  width: 2rem;
  bottom: 55px;
  left: 10px;
  z-index: 2;
  animation: my-btn 0.9s ease-in infinite;
}

.telegram {
  position: absolute;
  width: 1.3rem;
  bottom: 66px;
  right: 20px;
  z-index: 2;
  // background: white;
  // border-radius: 80%;
  // overflow: hidden;
  // animation: my-btn 0.9s ease-in infinite;
}

@keyframes my-btn {
  0% {
    transform: translateX(0 rpx);
    transform: scale(0.8);
  }

  50% {
    transform: translateX(20 rpx);
    transform: scale(1);
  }

  100% {
    transform: translateX(0 rpx);
    transform: scale(0.8);
  }
}
</style>
